// extracted by mini-css-extract-plugin
export default {"wrapper":"VerificationModal_wrapper__TBOKm","container":"VerificationModal_container__YS6dz","header":"VerificationModal_header__+l2Vd"};